import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import theme from '@/theme';
import styled from '@emotion/styled';
import Chip from '@mui/material/Chip';
import { FilterOption } from './FilterChipSelect';

const StyledChip = styled(Chip, {
    shouldForwardProp: prop => prop !== 'hasIcon',
})<{ hasIcon?: boolean }>`
    background: transparent;
    font-size: 14px;

    .MuiChip-label {
        display: flex;
        align-items: center;
        gap: 6px;
        padding-left: 2px;
    }

    svg {
        color: ${theme.colors.secondary[900]};
    }

    img {
        width: 16px;
    }
`;

const StyledLabel = styled.p`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

interface FilterChipProps {
    option: FilterOption;
}

export const FilterChip = ({ option }: FilterChipProps) => {
    if (option.isDivider) return null;

    const icon = option.icon ? typeof option.icon === 'string' ? <MaskedIcon src={option.icon} size="16px" /> : option.icon : null;

    return (
        <StyledChip
            id={`filter_${option.value}`}
            key={option.value}
            hasIcon={!!icon}
            label={
                <>
                    {icon}
                    <StyledLabel>{option.chipLabel || option.label}</StyledLabel>
                </>
            }
        />
    );
};
